export const FETCH_CASE_DETAILS_BY_CASE_ID = 'FETCH_CASE_DETAILS_BY_CASE_ID';
export const FETCH_CASE_DETAILS_BY_CASE_ID_SUCCESS =
  'FETCH_CASE_DETAILS_BY_CASE_ID_SUCCESS';
export const FETCH_CASE_DETAILS_BY_CASE_ID_FAIL =
  'FETCH_CASE_DETAILS_BY_CASE_ID_FAIL';

export const RELOAD_CASE_DETAILS = 'RELOAD_CASE_DETAILS';

export const fetchCaseDetailsByCaseId = (caseId) => ({
  type: FETCH_CASE_DETAILS_BY_CASE_ID,
  payload: caseId
});

export const fetchCaseDetailsByCaseIdSuccess = (caseDetails) => ({
  type: FETCH_CASE_DETAILS_BY_CASE_ID_SUCCESS,
  payload: caseDetails
});

export const fetchCaseDetailsByCaseIdFail = (message) => ({
  type: FETCH_CASE_DETAILS_BY_CASE_ID_FAIL,
  payload: { message }
});

export const reloadCaseDetails = () => ({
  type: RELOAD_CASE_DETAILS
});
